<template>
  <general-config :id="userId" :user-type="2"></general-config>
</template>
<script>
// import HUploader from "@/components/HUploader";
import GeneralConfig from "../../components/GeneralConfig";
export default {
  components: { GeneralConfig },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    userId() {
      return ~~this.$route.query.userId;
    },
  },
};
</script>

<style scoped>
</style>